/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".margen-bloque-texto[_ngcontent-%COMP%]{margin-left:80px}@media(max-width:1400px){.margen-bloque-texto[_ngcontent-%COMP%]{margin-left:0}}\n/*# sourceMappingURL=empresa.component.css.map*/"];
export { styles as styles };
